import * as React from "react";
import { Form, Select, Switch } from "antd";
import { ZAttribute } from "src/types/ZAttribute";
import styles from "./Sample2Settings.module.less";
import { ZSample2Settings } from "../ZSample2Settings";

const fi = (key: keyof ZSample2Settings) => key;

type PropsSample2Settings = {
  attrList: ZAttribute[];
};

export const Sample2Settings: React.FC<PropsSample2Settings> = (props) => {
  const { attrList } = props;
  const attrOptions = attrList.map(({ id, name }) => ({
    value: id,
    label: name,
  }));
  return (
    <div className={styles.box}>
      <label className={styles.label}>
        <Form.Item name={fi("mcEnableGradation")} noStyle>
          <Switch />
        </Form.Item>
        <div>Учитывать градацию Measurement chart?</div>
      </label>
      <Form.Item
        name={fi("mcAttrId")}
        label="Ссылка на Measurement chart"
        rules={[{ required: true }]}
      >
        <Select options={attrOptions} />
      </Form.Item>
      <Form.Item
        name={fi("sizeAttrId")}
        label="Ссылка на Size name"
        rules={[{ required: true }]}
      >
        <Select options={attrOptions} />
      </Form.Item>
    </div>
  );
};
